import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { EntityCertificationApi } from 'api';

export const filterEntityCertifications = createAsyncThunk(
  'entityCertification/filterEntityCertifications',
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await EntityCertificationApi.filter(params);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const filterAllEntityCertifications = createAsyncThunk(
  'entityCertification/filterAllEntityCertifications',
  async (_, { rejectWithValue }) => {
    try {
      const response = await EntityCertificationApi.filterAll();
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const createEntityCertification = createAsyncThunk(
  'entityCertification/createEntityCertification',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityCertificationApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const createMultiEntityCertification = createAsyncThunk(
  'entityCertification/createMultiEntityCertification',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityCertificationApi.createMulti(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntityCertification = createAsyncThunk(
  'entityCertification/updateEntityCertification',
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await EntityCertificationApi.update(params);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeEntityCertification = createAsyncThunk(
  'entityCertification/removeEntityCertification',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityCertificationApi.remove(id);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeMultiEntityCertification = createAsyncThunk(
  'entityCertification/removeMultiEntityCertification',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityCertificationApi.removeMulti(body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface State {
  tableList: Array<any>;
  orderList: Array<any>;
  list: Array<any>;
  reloadFlag: boolean;
}

const initialState: State = {
  tableList: [],
  orderList: [],
  list: [],
  reloadFlag: false,
};

const entityCertificationSlice = createSlice({
  name: 'entityCertification',
  initialState,
  reducers: {
    reloadEntityCertification(state) {
      state.reloadFlag = !state.reloadFlag;
    },
  },
});

const { actions, reducer: entityCertificationReducer } =
  entityCertificationSlice;

export const { reloadEntityCertification } = actions;

export default entityCertificationReducer;
